import { Country } from "../../earth/model/country";
import { LandLevel } from "../../earth/model/land";
import { Brand } from "../model/brand";
import { MetricType } from "../model/metricType";
import { UIContext } from "./uiContext" ;

export class UIGlobalState {
    landLevel = LandLevel.Continent;
    selectedMetricType = MetricType.Engagement;
    selectedBrands = Brand.AllBrands;
    selectedCountry: Country | null = null;
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/ui/uiGlobalState.tsx